/**
 * ChartEmpty: the one empty state of a patient-chart section (Antonin, 16 Oct: "'No procedures recorded for this
 * patient.' + 'Add procedure' is a good pattern, apply the same for allergies when none, and others where
 * applicable"). A dashed card with one line in the body role and, where production has an add action for the
 * section, its "Add ..." button under it. It is the Procedures empty state lifted out unchanged, so every section
 * that can be empty reads alike. A section with no add action in production (Medications, Labs, Notes, Drug
 * interactions, Appointments) shows the line alone: never an invented action.
 */
import { Button } from '@scripsteam/scrips-signal-ds';

export interface ChartEmptyProps {
  /** The one line, "No <things> recorded for this patient." */
  title: string;
  /** The section's own add label ("Add procedure"); with `onCta`, the button is drawn. */
  ctaLabel?: string;
  onCta?: () => void;
}

export function ChartEmpty({ title, ctaLabel, onCta }: ChartEmptyProps) {
  return (
    <div className="rounded-lg border border-dashed border-border-default p-8 text-center" data-slot="chart-empty">
      <p className="text-sm text-text-muted">{title}</p>
      {ctaLabel && onCta ? (
        <div className="mt-4">
          {/* The DS secondary button (neutral, 32 tall): an empty record shows one of these per section, and the
              design rules keep the filled blue for the page's one primary action (it was a filled blue button). */}
          <Button type="button" variant="secondary" size="sm" onClick={onCta}>
            {ctaLabel}
          </Button>
        </div>
      ) : null}
    </div>
  );
}
